module.exports = __webpack_public_path__ + "static/media/photograph.8795d562.svg";